export default "__VITE_ASSET__8h0ecG73__"